import React from 'react';
import PageBody from '../../components/pagebody/PageBody';
import { Route, Routes, useLocation } from 'react-router-dom';
import { RECIPIENT_SECTION_ROUTES } from './constants';
import RecipientList from './recipientlist/RecipientList';
import MoveRecipients from './moverecipients/MoveRecipients';
import AddRecipient from "../components/addrecipientnew/AddRecipient";
import AddRecipientSuccess from '../components/addrecipientnew/addrecipentsuccess/AddRecipientSuccess';
import EditRecipient from "../components/addrecipientnew/editrecipient/EditRecipient"
import { useDispatch, useSelector } from 'react-redux';
import { componentKey, setSelectedPayer } from './RecipientsSectionSlice';
import useGarbageCollector from '../../../libs/garbagecollector/garbageCollectorHooks';

export default function RecipientsSection() {

    useGarbageCollector(componentKey);
    const dispatch = useDispatch();
    const { selectedRecipient, selectedPayer } = useSelector(state => state[componentKey]);

    return (
        <PageBody>
            <Routes>
                <Route exact path={`/`} element={<RecipientList />} />
                <Route exact path={RECIPIENT_SECTION_ROUTES.ADD} element={<AddRecipient defaultSelectedPayer={selectedPayer} onChangePayerDropdownCb={(val) => dispatch(setSelectedPayer(val))} />} />
                <Route exact path={RECIPIENT_SECTION_ROUTES.RECIPIENT_ADDED} element={<AddRecipientSuccess />} />
                <Route exact path={RECIPIENT_SECTION_ROUTES.MOVE_RECIPIENTS} element={<MoveRecipients />} />

                {/* Edit Recipient */}
                <Route exact path={RECIPIENT_SECTION_ROUTES.EDIT} element={<EditRecipient recipientData={selectedRecipient} payer={selectedPayer} />} />
            </Routes>

        </PageBody>
    )
}